// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/** Traduções planos - Português */
export const plansTranslationsPt = {
  'plans.compare.title': 'Escolha seu plano',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.free.price': '$0 / mês',
  'plans.compare.foundation.price': '$15 / mês',
  'plans.compare.pro.price': '$19 / mês',
  'plans.compare.foundation.badge': '150 vagas limitadas',
  'plans.compare.cta.foundation': 'Tornar-me Founder',
  'plans.compare.cta.pro': 'Atualizar para PRO',
  'plans.compare.active': 'Plano atual',
  'plans.compare.limited': '',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.limit.title.messages': 'Limite de mensagens atingido',
  'plans.limit.message.messages': 'Você atingiu o limite de mensagens do seu plano. Atualize para FOUNDATION ou PRO para continuar.',
  'plans.limit.title.storage': 'Limite de armazenamento',
  'plans.limit.message.storage': 'Você atingiu o limite de armazenamento. Atualize seu plano para enviar mais arquivos.',
  'plans.limit.title.invitations': 'Limite de convites',
  'plans.limit.message.invitations': 'Você atingiu o limite de convites. Atualize seu plano para convidar mais contatos.',
  'plans.founder.remaining': 'Restam {count} cupos Founder',
  'plans.founder.remaining_last': 'Últimos {count} cupos Founder',
  'plans.founder.remaining_limited': 'Cupos limitados: restam {count}',
  'plans.founder.remaining_very_low': 'Restam só {count} cupos Founder',
  'plans.founder.soldout': 'Founder esgotado',
  'plans.limit.reached': 'Limite atingido — Melhorar plano',
  'plans.compare.pro.adjustment_notice': 'O preço pode ser ajustado conforme as condições do serviço.',
  'plans.compare.institucional.price': 'Preço sob consulta',
  'plans.compare.institucional.title': 'Title',
  'plans.compare.yourPlan': 'YourPlan',
  'plans.modal.title': 'Atualizar plano',
  'plans.modal.comparison_title': 'Comparação de planos',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.modal.free.line1': '30.000 caracteres por mês por conta.',
  'plans.modal.free.line2': 'Até 2 contatos por usuário.',
  'plans.modal.free.line3': 'Até 2 conversas ativas por conta.',
  'plans.modal.free.line4': 'Sem anexos de arquivo nem espaço de armazenamento.',
  'plans.modal.free.line5': 'Sem exportação de dados.',
  'plans.modal.free.line6': 'Histórico de mensagens até 30 dias.',
  'plans.modal.free.line7': 'Apenas 1 dispositivo por usuário.',
  'plans.modal.premium.line1': '300.000 caracteres por mês por conta.',
  'plans.modal.premium.line2': 'Até 100 contatos por usuário.',
  'plans.modal.premium.line3': 'Conversas e chats ilimitados (tenant).',
  'plans.modal.premium.line4': 'Até 50 MB de armazenamento (tenant).',
  'plans.modal.premium.line5': 'Até 3 dispositivos por usuário.',
  'plans.modal.premium.line6': 'Convites ilimitados (tenant).',
  'plans.modal.premium.line7': 'Inclui exportação, tradução automática e arquivos conforme limites do plano.',
  'plans.modal.premium_block_heading': 'Limites de uso do motor (premium)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Programa Founder',
  'plans.modal.foundation.categories_title': 'Categorias Founder ({slots} vagas)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'Posição 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'Os primeiros a apoiar o projeto. Máxima prioridade histórica.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'Posição 26–75',
  'plans.modal.foundation.cat_early_desc': 'Apoio antecipado com reconhecimento especial.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'Posição 76–150',
  'plans.modal.foundation.cat_std_desc': 'Vaga Founder dentro das 150 posições.',
  'plans.modal.foundation.advantages_title': 'Vantagens Founder',
  'plans.modal.foundation.adv1': 'Acesso ao pool Founder limitado ({slots} vagas numeradas).',
  'plans.modal.foundation.adv2': 'Reconhecimento como usuário fundador da ArChat.',
  'plans.modal.foundation.adv3': 'Selo e presença Founder na experiência do produto.',
  'plans.modal.foundation.adv4': 'Prioridade histórica e status conforme sua posição (1–150).',
  'plans.modal.foundation.adv5': 'Benefício contínuo ligado ao seu acesso Founder enquanto a política vigente se aplicar.',
  'plans.modal.pro.tagline': 'Premium padrão — sem componente Founder',
  'plans.badges.foundation': 'Founder',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'Plano gratuito',
  'plans.free.price': '$0 / mês',
  'plans.free.features.contacts': 'Até 2 contatos por usuário',
  'plans.free.features.conversations': 'Até 2 conversas ativas por conta',
  'plans.free.features.no_export': '30.000 caracteres/mês por conta; 34 mensagens/dia e 1.000/mês; sem exportação',
  'plans.free.features.no_advanced': 'Sem arquivos nem armazenamento; histórico 30 dias; 1 dispositivo por usuário',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Plano Founder',
  'plans.foundation.price': '$15 / mês',
  'plans.foundation.features.contacts': 'Mesmo contrato premium que PRO (até 100 contatos por usuário)',
  'plans.foundation.features.conversations': 'Conversas e chats ilimitados (tenant); mesmos limites que PRO',
  'plans.foundation.features.badge': 'Programa Founder (150 vagas numeradas)',
  'plans.foundation.features.support': 'USD 15/mês enquanto houver vagas Founder',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Plano Pro',
  'plans.pro.price': '$19 / mês',
  'plans.pro.features.contacts': 'Até 100 contatos por usuário',
  'plans.pro.features.conversations': 'Conversas e chats ilimitados (tenant); 1.667 msg/dia, 50k/mês',
  'plans.pro.features.export': 'Até 50 MB (tenant); exportação, tradução automática e arquivos conforme o plano',
  'plans.pro.features.notifications': 'Até 3 dispositivos por usuário; convites ilimitados (tenant)',
  'plans.actions.free': 'Plano atual',
  'plans.actions.foundation': 'Tornar-me Founder',
  'plans.actions.pro': 'Atualizar para PRO',
  'plans.badges.recommended': 'RECOMENDADO',
  'plans.badges.limited': 'LIMITADO',
  'plans.payments_disabled.title': 'Assinaturas',
  'plans.payments_disabled.message': 'As assinaturas estão sendo habilitadas gradualmente. Você pode ver os planos disponíveis e seus benefícios.',
  'plans.payments_disabled.confirm': 'OK',
};